export const environment = {
  envName: 'stage',
  production: false,
  companyRedirectUrl: 'https://mobeus-stage.com',
  browserLinkUrl: 'https://gro9u.com'
};
